import { useDeviceDefinition } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { CatalogDefinition, DeviceDefinitionEdit } from "@/features/catalog";
import {
  deviceDefinitionRouteId,
  deviceDefinitionUrlFromRouteId,
} from "@/features/catalog/lib/device-definition-route";

export const Route = createFileRoute("/catalog/devices/$deviceId_/edit")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canRead("DeviceDefinition")) throw redirect({ to: "/catalog/devices" });
  },
  component: DeviceEditRoute,
});

function DeviceEditRoute() {
  const { deviceId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const definition = useDeviceDefinition(deviceDefinitionUrlFromRouteId(deviceId));
  const back = (url = definition?.definitionUrl) =>
    url
      ? navigate({ to: "/catalog/devices/$deviceId", params: { deviceId: deviceDefinitionRouteId(url) } })
      : navigate({ to: "/catalog/devices" });

  if (!definition) {
    return <CatalogDefinition.NotFound label="Device" backTo="/catalog/devices" backLabel="Back to devices" />;
  }

  return (
    <DeviceDefinitionEdit
      key={definition.definitionUrl}
      definition={definition}
      canEdit={permissions.canWrite("DeviceDefinition")}
      onDone={back}
      onCancel={() => back()}
    />
  );
}
